import RoundedImage from './index';
import { RoundedImageSizes } from './RoundedImage';
import { getDefaultUserImageUrl } from '../../../utils/functions';

interface AnonymousRoundedImageProps {
  size?: RoundedImageSizes;
  className?: string;
}

/**
 * A specific type of RoundedImage component made for convenience. Shows an anonymous user profile image.
 * @param size
 * @param className
 * @constructor
 */
export default function AnonymousImage({ size = 'sm', className = '' }: AnonymousRoundedImageProps) {
  return <RoundedImage className={className} size={size} src={getDefaultUserImageUrl()} alt="Anonymous user profile" />;
}
